'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'plate-wheat';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e55a';
var svgPathData = 'M224 112l0 5.3c-18.6-6.6-32-24.4-32-45.3l0-5.3c18.6 6.6 32 24.4 32 45.3zM160 48l0 24c0 44.2 35.8 80 80 80 8.8 0 16-7.2 16-16l0-24c0-44.2-35.8-80-80-80-8.8 0-16 7.2-16 16zM48 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 64zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 144zm16 96c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zM336 117.3c-18.6-6.6-32-24.4-32-45.3l0-5.3c18.6 6.6 32 24.4 32 45.3l0 5.3zM288 32c-8.8 0-16 7.2-16 16l0 24c0 44.2 35.8 80 80 80 8.8 0 16-7.2 16-16l0-24c0-44.2-35.8-80-80-80zm160 80l0 5.3c-18.6-6.6-32-24.4-32-45.3l0-5.3c18.6 6.6 32 24.4 32 45.3zM384 48l0 24c0 44.2 35.8 80 80 80 8.8 0 16-7.2 16-16l0-24c0-44.2-35.8-80-80-80-8.8 0-16 7.2-16 16zM304 253.3l0-5.3c0-20.9 13.4-38.7 32-45.3l0 5.3c0 20.9-13.4 38.7-32 45.3zM352 168c-44.2 0-80 35.8-80 80l0 24c0 8.8 7.2 16 16 16 44.2 0 80-35.8 80-80l0-24c0-8.8-7.2-16-16-16zM192 248c0-20.9 13.4-38.7 32-45.3l0 5.3c0 20.9-13.4 38.7-32 45.3l0-5.3zm64-64c0-8.8-7.2-16-16-16-44.2 0-80 35.8-80 80l0 24c0 8.8 7.2 16 16 16 44.2 0 80-35.8 80-80l0-24zm160 69.3l0-5.3c0-20.9 13.4-38.7 32-45.3l0 5.3c0 20.9-13.4 38.7-32 45.3zM464 168c-44.2 0-80 35.8-80 80l0 24c0 8.8 7.2 16 16 16 44.2 0 80-35.8 80-80l0-24c0-8.8-7.2-16-16-16zM129.8 441.1c-5.5-9.5-15.5-15.6-26.5-16-39.3-1.5-70.7-33.6-71.3-73.1l448 0c-.5 39.5-32 71.6-71.3 73.1-11 .4-21 6.5-26.5 16-2.4 4.2-6.9 6.9-11.9 6.9l-228.6 0c-5 0-9.5-2.7-11.9-6.9zM31 320c-17.1 0-31 13.9-31 31 0 57.3 45.3 103.9 102.1 106.1 7.9 13.7 22.7 22.9 39.6 22.9l228.6 0c17 0 31.8-9.2 39.6-22.9 56.7-2.2 102.1-48.8 102.1-106.1 0-17.1-13.9-31-31-31L31 320z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPlateWheat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;